"use client";
import Image from "next/image";
import { useEffect, useState } from "react";

const HeroImage = () => {
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    handleResize(); // Set initial width
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Image
        src={windowWidth < 1024 ? "/cropped-3.webp" : "/new-hero.webp"}
        alt="hero"
        width={windowWidth < 1024 ? 1000 : 6200}
        height={windowWidth < 1024 ? 1000 : 6200}
        priority={true}
        className="object-cover max-w-full h-full absolute z-0"
      />
      <span className="w-full h-full bg-black-bg/70 z-10 absolute"></span>
    </>
  );
};

export default HeroImage;
